export const emailValidation = value => {
  if (value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,24}$/i.test(value)) {
    return 'Invalid email address';
  }
  return null;
};
